import { render, staticRenderFns } from "./BchService.vue?vue&type=template&id=63a03562&scoped=true"
import script from "./BchService.vue?vue&type=script&lang=js"
export * from "./BchService.vue?vue&type=script&lang=js"
import style0 from "./BchService.vue?vue&type=style&index=0&id=63a03562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a03562",
  null
  
)

export default component.exports